import { render, staticRenderFns } from "./ZakatMaal.vue?vue&type=template&id=56edcd4e"
import script from "./ZakatMaal.vue?vue&type=script&lang=js"
export * from "./ZakatMaal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports